import Vue from 'vue'
import Router from 'vue-router'

import { store } from './store'
import About from './components/About.vue'
import Home from './components/Home.vue'
// import Index from './components/Index.vue'

/* authentication */
import SignIn from '@/components/Auth/Signin'
import Register from '@/components/Auth/Register'
import Registered from '@/components/Auth/Registered'
import Forgot from '@/components/Auth/Forgot'
import Confirm from '@/components/Auth/Confirm'
import Changed from '@/components/Auth/Changed'
import Resend from '@/components/Auth/Resend'
import Users from '@/components/Admin/Users'

/* Profiles */
import Profile from '@/components/Profile/Index'

/* Cases and encounters */
import Case from '@/components/Case/CaseViewer'

// feedback.
import Feedback from './components/Feedback.vue'
// import NotFound from './components/404.vue'

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  routes: [
    // { path: '/', redirect: '/home' },
    // { path: '/', name: 'Index', component: Index },
    { path: '/', name: 'About', component: About },
    { path: '/home', name: 'Home', meta: { requiresAuth: true }, component: Home },
    /* Authentication */
    { path: '/signin', name: 'SignIn', component: SignIn },
    { path: '/register', name: 'Register', component: Register },
    { path: '/registered', name: 'Registered', component: Registered },
    { path: '/forgot', name: 'Forgot', component: Forgot },
    { path: '/confirm', name: 'Confirm', component: Confirm },
    { path: '/changed', name: 'Changed', component: Changed },
    { path: '/resend', name: 'Resend', component: Resend },
    /* Profiles */
    { path: '/profile', name: 'Profile', meta: { requiresAuth: true }, component: Profile },
    { path: '/feedback', name: 'Feedback', meta: { requiresAuth: true }, component: Feedback },
    { path: '/users', name: 'Users', meta: { requiresAuth: true }, component: Users },

    /** Case */
    { path: '/case/:caseId', name: 'Case', meta: { requiresAuth: true }, component: Case }

    /** Default fallback route. */
    // { path: '/*', name: 'NotFound', component: NotFound }
  ],
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  // const isAuthenticated = store.state.auth.authenticated
  // console.log(store.getters)
  // const isAuthenticated = (localStorage.getItem('authenticated') === 'true') // store.getters['getAuthenticated']
  // const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  // console.log(`Check authenticated: ${isAuthenticated}`)
  // console.log(`Auth check: `, store.state.auth.userPool)
  // console.log(`From path: ${from.path}, to path: ${to.path}`)
  // if (to.path === from.path) return
  // if (requiresAuth && !isAuthenticated) next('/signin')
  // else if (!requiresAuth && isAuthenticated) next('/home')
  // else next()
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    const isAuthenticated = store.getters.getAuthenticated
    if (!isAuthenticated) {
      next({
        path: '/signin',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router



// WEBPACK FOOTER //
// ./src/routes.js